import { RedcatApiHandler } from 'polygon-utils';

import { storeMemberOffers } from '../reducers/memberOffers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMember } from '../selectors';

export const fetchMemberOffers = createAsyncThunk(
  '$fetchMemberOffers',
  async (
    data: {
      showRedeemedCoupons?: boolean;
      showExpiredCoupons?: boolean;
    },
    { dispatch, rejectWithValue },
  ) => {
    try {
      /**
       * The reason why we don't get showRedeemedCoupons, showExpiredCoupons
       * straight from polygon ordering is because maybe one day we could
       * implement some sort of filtering in our front end for users.
       */
      const { showRedeemedCoupons, showExpiredCoupons } = data;

      const path = `/api/v1/profile/coupons?hideredeemed=${
        showRedeemedCoupons ? '0' : '1'
      }&hideexpired=${showExpiredCoupons ? '0' : '1'}`;

      const response: { data: RawOffer[] } =
        await RedcatApiHandler.authorisedFetch({ method: 'GET', path });

      dispatch(storeMemberOffers(response.data));
    } catch (e) {
      console.warn('Fetch offers thunk failed', { e });
      return rejectWithValue(e);
    }
  },
  {
    // /profile/coupons is member-only, so without a member the request can only 403.
    // On a cold start from a push deep link the Offers screen can mount before
    // checkAuthToken has set the member.
    condition: (_data, { getState }) =>
      !!getMember(getState() as EntireFrontendState),
  },
);
